import { css } from 'styled-system/css';
import {
  BILLING_FREQUENCIES,
  type BillingFrequency,
} from '../../billing/billingFrequency';
import { FrequencyButton } from './FrequencyButton';

export function FrequencyToggle({
  frequency,
  onSelect,
}: {
  frequency: BillingFrequency;
  onSelect: (frequency: BillingFrequency) => void;
}) {
  return (
    <div
      role="group"
      aria-label="Billing period"
      className={css({
        display: 'inline-flex',
        padding: '0.5',
        border: '1px solid token(colors.border.hairline)',
        background: 'bg.surface',
      })}
    >
      {BILLING_FREQUENCIES.map((f) => (
        <FrequencyButton
          key={f.value}
          frequency={f.value}
          label={f.label}
          selected={frequency === f.value}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
